const initCtaScrub = () => {
  const els = document.querySelectorAll('[data-js="cta"]');
  if (!els.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  const clamp01 = n => Math.max(0, Math.min(1, n));
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

  const computeProgress = el => {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    const start = vh * 0.90;
    const end = vh * 0.20;

    return clamp01((start - rect.top) / (start - end));
  };

  let rafId = 0;

  const tick = () => {
    els.forEach(el => {
      const p = easeOutCubic(computeProgress(el));

      const fromY = el.dataset.fromY !== undefined ? parseFloat(el.dataset.fromY) : 25;
      const fromScale = el.dataset.fromScale !== undefined ? parseFloat(el.dataset.fromScale) : 0.85;

      const y = lerp(fromY, 0, p);
      const s = lerp(fromScale, 1, p);

      el.style.transform = `translate3d(0, ${y}px, 0) scale(${s})`;
    });

    rafId = requestAnimationFrame(tick);
  };

  rafId = requestAnimationFrame(tick);
  window.addEventListener('beforeunload', () => cancelAnimationFrame(rafId));
};

document.addEventListener('DOMContentLoaded', initCtaScrub);
